export default __webpack_public_path__ + "static/media/Chestguard of the Tireless Defender.164dd341.jpg";